export default __webpack_public_path__ + "static/media/sampleTwoColumns.7d6c19bb.svg";